module.exports = __webpack_public_path__ + "c23534acbeddbaadfd0ab2d2bbfdfc84.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-Bold.ttf
// module id = 1242
// module chunks = 0